import React, { ReactNode } from 'react';
import clsx from 'clsx';
import { Gap } from '@common/components';

export const ButtonGroup = ({
  align,
  className,
  children,
}: {
  align?: 'right';
  className?: string;
  children: ReactNode;
}) => {
  return (
    <Gap
      className={clsx('wk-button-group', className)}
      justify={align === 'right' ? 'end' : 'normal'}
      data-testid="wk-button-group"
    >
      {children}
    </Gap>
  );
};
